
import { createNamespacedHelpers } from 'vuex'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { getMobileOperatingSystem, IOS } from '../../libs/utils/os'
const { mapActions, mapGetters } = createNamespacedHelpers('plp')
const { mapGetters: mapGetterSa } = createNamespacedHelpers('sizeAdvisor')
import qs from 'qs'
import {
  ACTION_TOGGLE_SIDEBAR,
  ACTION_TOGGLE_PLP_FILTER,
  ACTION_UPDATE_FACETS,
} from '@store/actions/plp'


/* a.sonis:
  v-scroll-lock works and prevent errors for scroll body behind for IOS mobile but it mess with Android, Chrome and Safari mobile simulator
  instead enableBodyScroll and disableBodyScroll works perfectly with all the others, but don't solve the double scrolling for IOS
  so let's combine them
*/

export default {
  name: 'SghSidebar',
  data() {
    return {
      windowInnerHeight: window.innerHeight,
      scrollLock: false,
      os: getMobileOperatingSystem(),
      closePanel: false,
      focusTrap: false,
    }
  },
  computed: {
    ...mapGetters(['ui']),
    ...mapGetterSa(['isActiveSa']),
    showIOS() {
      return this.ui.sidebar && this.os === IOS
    },
    showOthers() {
      return this.ui.sidebar && this.os !== IOS
    },
    isMobilePortrait() {
      return window.innerWidth < 640
    },
    getHeight() {
      return this.$refs.sidebarPanel.clientHeight
    },
  },
  watch: {
    windowInnerHeight() {
      this.updateVarHeaderVh()
    },
    'ui.sidebar'(newValue) {
      if(!newValue) {
        this.focusTrap = false
      }
      if (this.$mq === 'tablet') {
        this.scrollLock = newValue
        if (this.os !== IOS) {
          if (newValue) {
            disableBodyScroll(this.$el)
          } else {
            enableBodyScroll(this.$el)
          }
        }
      }
    },
  },
  mounted() {
    this.panelStatus()
    this.scrollAccordion()
  },
  methods: {
    ...mapActions({
      toggleSidebar: ACTION_TOGGLE_SIDEBAR,
      toggleFilter: ACTION_TOGGLE_PLP_FILTER,
      updateFacets: ACTION_UPDATE_FACETS,
    }),
    applyFilters() {
      let facetParamsNormalized = qs.parse(decodeURIComponent(window.location.search), {
        ignoreQueryPrefix: true,
      })
      const currentPage = facetParamsNormalized.currentPage ? facetParamsNormalized.currentPage : 1
      this.closePanel = true
      setTimeout(() => {
        this.updateFacets({
          override: true,
          currentPage: currentPage,
          updateUi: {
            plpLoadingProducts: true,
          },
        })
        this.toggleSidebar()
        this.closePanel = false
      }, 600)
    },
    updateVarHeaderVh: function() {
      if (this.$mq === 'tablet') {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vhheader', `${vh}px`)
      }
    },
    panelStatus() {
      this.$root.$on('panelStatusOn', () => (this.closePanel = true))
      this.$root.$on('panelStatusOff', () => (this.closePanel = false))
    },
    scrollAccordion() {
      this.$root.$on('scrollPositionSidebar', elScroll => {
        setTimeout(async function() {
          await elScroll.scrollIntoView({ block: 'start', behavior: 'smooth' })
        }, 400)
      })
    },
    onAfterEnter() {
        this.focusTrap = true
    },

  },
}
